export default {
  SET_CONFIG(state, config) {
    state.programYear = config.programYear;
    state.options = config.options;
  },
};
